const updateDomainGymErrors = (state, { payload: { errors } }) => {
	state.errors = errors;
};

export default updateDomainGymErrors;
